import { Outlet, createFileRoute, redirect } from "@tanstack/react-router"

import { isPlatformLoggedIn, isTenantSubdomainHost } from "../../utils/platformAuth"

export const Route = createFileRoute("/platform/spaces")({
  component: PlatformSpacesLayout,
  beforeLoad: async () => {
    if (isTenantSubdomainHost()) {
      throw redirect({ to: "/login" })
    }
    if (!isPlatformLoggedIn()) {
      throw redirect({ to: "/platform/login" })
    }
  },
})

function PlatformSpacesLayout() {
  return <Outlet />
}
